import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import HeaderFPage from './pages/HeaderFPage';
import ErrorPage from './pages/ErrorPage';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const Contact = lazy(() => import('./pages/Contact'));
const Services = lazy(() => import('./pages/Services'));
const Products = lazy(() => import('./pages/Products'));
function App() {
  return (
    <>
      <Routes>
        <Route path='/' element={<HeaderFPage />}>
          <Route path='/' element={<HomePage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/contactus' element={<Contact />} />
          <Route path='/services' element={<Services />} />
          <Route path='/products' element={<Products />} />
        </Route>
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
